import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../api';
import type { GcpCertDetailsUpdate } from '../../api/gcpCerts/updateCertDetails';

const useUpdateGcpCertDetails = (gcpCertID: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (details: Record<string, unknown>) =>
      api.gcpCerts.updateCertDetails({
        gcpCertID,
        action: 'UPDATE_DETAILS',
        details,
      } as GcpCertDetailsUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gcpCerts'] });
      queryClient.invalidateQueries({ queryKey: ['gcpCert', gcpCertID] });
    },
  });
};

export default useUpdateGcpCertDetails;
